import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ORDER_DIRECTIONS, type FilterMode } from '@/filters';
import type { TaskCreationSource, TaskScope, TaskStatus } from '@/features/tasks/types';

export const tasksFilterAtom = atomWithStorage<{
  status?: TaskStatus[];
  statusMode?: FilterMode;
}>('tasks-filter', {}, undefined, { getOnInit: true });

export const tasksWorkspaceFilterAtom = atomWithStorage<Partial<Record<string, string>>>(
  'tasks-workspace-filter',
  {},
  undefined,
  { getOnInit: true },
);

export const tasksDisplayAtom = atomWithStorage<{
  view: 'list' | 'board';
  tab?: 'assigned' | 'created' | 'all';
  showArchived?: boolean;
  order: { field: 'dueDate' | 'updatedAt'; direction: (typeof ORDER_DIRECTIONS)[number] };
}>(
  'tasks-display',
  {
    view: 'list',
    tab: 'assigned',
    order: { field: 'dueDate', direction: 'asc' },
  },
  undefined,
  { getOnInit: true },
);

export const tasksCollapsedGroupsAtom = atomWithStorage<(TaskStatus | 'past' | 'today')[]>(
  'tasks-collapsed-statuses',
  ['closed'],
);

export const createTaskAtom = atom<{
  open: boolean;
  scope?: TaskScope;
  source?: TaskCreationSource;
  status?: 'open' | 'in_progress';
}>({ open: false });
